import { Components, Theme } from "@mui/material"

export const MuiTableHead: Required<Components<Theme>>["MuiTableHead"] = {
  styleOverrides: {
    root: ({ theme: { palette } }) => ({
      backgroundColor: palette["bg-secondary_subtle"],
      color: palette["text-quaternary"],
      zIndex: 1,
    }),
  },
}
